import { useEffect } from "react";

const NavigateToBackOffice = () => {
  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_API_URL}/backoffice`;
  }, []);
  return null;
};

export default NavigateToBackOffice;
